import { IRemovedChartsRepositoryCB } from "modules/dashboard/application/interfaces/IRemovedChartsRepository";

const RemoveRemovedChartsUseCase = (_dashboardRepository: IRemovedChartsRepositoryCB): void => {
    const dashboardRepository = _dashboardRepository();
    dashboardRepository.remove();
}

export default RemoveRemovedChartsUseCase;